import React from "react";
import { Box, Typography } from "@material-ui/core";

const SalesPerSquareFootTitle = () => {
    const label = "Sales per square foot";

    return (
        <Box display="flex" data-cy="sales-per-square-foot-title" pb={1}>
            <Typography variant="h6">{label}</Typography>
        </Box>

    );
};

export default SalesPerSquareFootTitle;
